import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { AppText, AppIcon, Box, Subheader, TooltipButton, styled, Row } from '@streem/ui-react';
import { recordElementClicked } from '@streem/analytics';
import { getDuration, formatDateColumn } from '@streem/toolbox';
import { useHostRecentCallLog } from '../../../context/call_log';
export const RecentCallsLogForHostUser = ({ currentRoomId }) => {
    const [hostUserCallLog, setHostUserCallLog] = useState([]);
    const getCallLogHistory = useHostRecentCallLog();
    const elementClickedId = 'open-call-details-from-in-call-experience';
    useEffect(() => {
        if (getCallLogHistory) {
            const getCallHistory = async () => {
                const results = await getCallLogHistory();
                setHostUserCallLog(results);
            };
            getCallHistory();
        }
    }, [getCallLogHistory]);
    const hostCallLogWithoutCurrentCall = hostUserCallLog?.filter(call => call.roomSid !== currentRoomId);
    const hasCalls = hostCallLogWithoutCurrentCall && hostCallLogWithoutCurrentCall.length > 0;
    const handleOpenCallDetails = useCallback((url) => {
        if (!url)
            return;
        recordElementClicked(elementClickedId);
        window.open(url, '_blank', 'noopener,noreferrer');
    }, []);
    return (_jsx(Box, { mt: "40px", children: _jsxs(Box, { as: "section", "data-testid": "recent-calls-section", children: [_jsx(Subheader, { size: "mediumLarge", "data-testid": "recent-calls-heading", children: "Recent Calls" }), hasCalls ? (hostCallLogWithoutCurrentCall.map(call => {
                    const [day, time] = formatDateColumn(call.startTime?.toISOString(), {
                        returnDayAndTime: true,
                        dateFormat: { month: 'short', day: 'numeric', year: 'numeric' },
                    });
                    const duration = getDuration(call.startTime, call.endTime);
                    return (_jsx(TooltipButton, { disabledTooltip: !call.callDetailsUrl, width: "290px", tooltipPlacement: "top", tooltipMessage: _jsxs(Row, { alignItems: "center", style: { gap: '10px' }, children: [_jsx(Box, { flexBasis: "10%", children: _jsx(AppIcon, { name: "OpenLinkIcon" }) }), _jsxs(TruncatedText, { children: ["Open ", `${call.urlHostname}${call.callDetailsUrl}`] })] }), variant: "tertiary", disabledButton: !call.callDetailsUrl, onClick: () => handleOpenCallDetails(call.callDetailsUrl), buttonText: _jsx("time", { dateTime: call.startTime?.toISOString(), children: `${day} at ${time} - ${duration}` }) }, call.roomSid));
                })) : (_jsx(AppText, { as: "p", color: "medium", children: "You have no recent calls for this customer." }))] }) }));
};
const TruncatedText = styled(AppText)(() => ({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
}));
//# sourceMappingURL=recent_calls_log_host.js.map